module.exports = __webpack_public_path__ + "static/media/teenpatti20.3e249f94.jpeg";